import { withInstall } from '../utils'
import _MessageBox from './MessageBox'
import './index.scss'

export const MessageBox = withInstall(_MessageBox)
export default MessageBox
